<div class="pb-2 bg-white flex justify-between @container">
  <div class="flex items-center">
    @if (languageSelection) {
      <app-language-selection [displayAllLanguages]="true" class="hidden sm:inline-block"></app-language-selection>
    }
    @if (displaySwPartNumberSelection) {
      <app-sw-part-number-selection class="ms-2 hidden sm:inline-block"></app-sw-part-number-selection>
    }
  </div>
  <div class="flex space-x-2 items-center">
    <button
      (click)="toggleFilter()"
      type="button"
      [ngClass]="filtersAreSet() ? 'text-amazone-orange' : 'text-white'"
      class="bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 h-10 w-10 hidden md:inline-block cursor-pointer"
      appAgentAction
      agent="dtc-table-search-filter-toggle"
      businessObject="dtc"
      action="toggle"
    >
      <app-filter-icon></app-filter-icon>
    </button>
    @if (!recyclingModeEnabled && downloadDisabled === false && csvExportEnabled) {
      <button
        data-tooltip-target="tooltip-download"
        data-tooltip-placement="right"
        (click)="download()"
        type="button"
        class="text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 h-10 w-10 hidden md:inline-block cursor-pointer"
        appAgentAction
        agent="dtc-table-search-download"
        businessObject="dtc"
        action="download"
      >
        <app-download-icon></app-download-icon>
      </button>

      <div
        id="tooltip-download"
        role="tooltip"
        class="absolute z-10 invisible px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 hidden md:inline-block tooltip"
      >
        Download DTCs for this SwPartNumber as CSV file
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>
    }

    @if (!recyclingModeEnabled && restoreDisabled === false) {
      <a
        *appIfPolicySatisfied="policy.canReadSoftDeleted"
        [routerLink]="['/dtc/recycling']"
        data-tooltip-target="tooltip-restore-dtc"
        data-tooltip-placement="right"
        class="text-white bg-amazone-gray hover:bg-gray-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 h-10 w-10 hidden md:inline-block cursor-pointer"
      >
        <app-restore-icon></app-restore-icon>
      </a>
      <div
        *appIfPolicySatisfied="policy.canReadSoftDeleted"
        id="tooltip-restore-dtc"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 tooltip"
      >
        Open list of DTCs marked as deleted
        <div class="tooltip-arrow" data-popper-arrow></div>
      </div>
      <div
        *appIfPolicyNotSatisfied="policy.canReadSoftDeleted"
        class="text-white bg-gray-300 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 h-10 w-10 hidden md:inline-block"
      >
        <app-restore-icon></app-restore-icon>
      </div>
    }

    <div class="relative hidden @4xl:w-md lg:inline-block">
      <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg
          class="w-4 h-4 text-gray-500 dark:text-gray-400"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
      </div>
      <input
        type="search"
        id="table-search"
        class="block w-full p-4 h-10 ps-10 text-sm text-gray-900 border border-gray-500 rounded-lg bg-gray-50 focus:ring-amazone-orange focus:border-amazone-orange"
        placeholder="Search DTCs"
        [(ngModel)]="searchQuery.searchPattern"
        (keyup)="searchByKey($event)"
      />
      <button
        (click)="search()"
        type="button"
        class="text-gray-800 absolute end-2.5 bottom-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-2 cursor-pointer hover:-translate-0.5 hover:scale-110 hover:text-amazone-orange transition-all duration-150"
        appAgentAction
        agent="dtc-table-search-search"
        businessObject="dtc"
        action="search"
      >
        <app-search-icon></app-search-icon>
      </button>
    </div>

    @if (helpPopoverEnabled) {
      <div class="ms-auto mt-1 absolute end-0 -top-[1.6rem]">
        <app-help-popover [iconColor]="'text-amazone-orange'" [paragraphs]="paragraphs"></app-help-popover>
      </div>
    }
  </div>
</div>
<app-dtc-filter
  [isOpen]="filterVisible"
  [recyclingModeEnabled]="recyclingModeEnabled"
  (filterChanged)="filterApplied($event)"
  (closed)="filterVisible = false"
></app-dtc-filter>
